module.exports = __webpack_public_path__ + "img/collection-weddingRingsBudgetLow.955d01a.jpg";